import { isType } from '@mtna/common';
import { instanceofProcessStatusDetail, ProcessStatusDetail } from '@mtna/process-manager-ui';

import { OptionSet } from '../option/option-set.model';
import { PackagingCompletionDetails } from './packaging-completion-details.model';

/**
 * Backend model:
 * https://bitbucket.org/mtnaus/rds-packaging/src/develop/rds-packaging/src/main/java/us/mtna/rds/packaging/process/PackagingProcessStatusDetail.java
 */
export interface PackagingProcessStatusDetail extends ProcessStatusDetail<PackagingCompletionDetails> {
  methodName?: string;
  resourceName?: string;
  resourceUri?: string;
  request?: string;
  parameters?: { [id: string]: string[] };
  optionSets?: OptionSet[];
}

/** Determines whether something is a {@link PackagingProcessStatusDetail}. Checks for existence of `methodName`, `request`, & `parameters` */
export function instanceOfPackagingProcessStatusDetail(something: unknown): something is PackagingProcessStatusDetail {
  return (
    instanceofProcessStatusDetail<PackagingCompletionDetails>(something) &&
    isType<PackagingProcessStatusDetail>(something, 'methodName', 'request', 'parameters')
  );
}
